import { Controller } from '@hotwired/stimulus';

// Steps through a fixed set of slides with previous/next buttons, wrapping around at either end:
// data: { controller: "slider" } on the wrapper, slide targets (all but the first rendered
// `hidden`, so there is no flash before connect) and an optional counter target ("2 / 5").
export default class extends Controller {
  static targets = ['slide', 'counter'];

  connect() {
    this.index = 0;
    this.show();
  }

  next() {
    this.index = (this.index + 1) % this.slideTargets.length;
    this.show();
  }

  previous() {
    this.index = (this.index - 1 + this.slideTargets.length) % this.slideTargets.length;
    this.show();
  }

  show() {
    this.slideTargets.forEach((slide, i) => slide.classList.toggle('hidden', i !== this.index));
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.index + 1} / ${this.slideTargets.length}`;
    }
  }
}
